module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.showFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackMessage,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), _c('form', [(!_vm.syncConfig) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('model-select', {
    attrs: {
      "options": _vm.dataSourceOptions,
      "placeholder": "Select Helium datasouce"
    },
    model: {
      value: (_vm.selectedDataSourceOption),
      callback: function($$v) {
        _vm.selectedDataSourceOption = $$v
      },
      expression: "selectedDataSourceOption"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('model-select', {
    attrs: {
      "options": _vm.dataSourceApps,
      "placeholder": "Select Helium app"
    },
    model: {
      value: (_vm.dataSourceApp),
      callback: function($$v) {
        _vm.dataSourceApp = $$v
      },
      expression: "dataSourceApp"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig) ? _c('div', [_c('button', {
    staticClass: "btn btn-xs btn-info pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleExpand
    }
  }, [(!_vm.expand) ? _c('div', [_vm._v("Show Advanced")]) : _c('div', [_vm._v("Hide Advanced")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("HeliumJourney Sync Middleware:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Middleware Sync Status")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledRadio),
      expression: "enabledRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio1",
      "name": "enabledRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledRadio),
      expression: "enabledRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio2",
      "name": "enabledRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledRadio = "Disabled"
      }
    }
  }), _vm._v("\n                      Disabled\n                  ")])])])]), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Journey To Helium:")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableHeliumToJourneyRadio),
      expression: "enableHeliumToJourneyRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio3",
      "name": "enableJourneyToHeliumRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableHeliumToJourneyRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enableHeliumToJourneyRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableHeliumToJourneyRadio),
      expression: "enableHeliumToJourneyRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio4",
      "name": "enableJourneyToHeliumRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableHeliumToJourneyRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enableHeliumToJourneyRadio = "Disabled"
      }
    }
  }), _vm._v("\n                    Disabled\n                  ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled data updated on Journey will be synced to Helium's backend database.")])])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Helium To Journey:")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableJourneyToHeliumRadio),
      expression: "enableJourneyToHeliumRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio5",
      "name": "enabledHeliumToJourneyRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableJourneyToHeliumRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enableJourneyToHeliumRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableJourneyToHeliumRadio),
      expression: "enableJourneyToHeliumRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio6",
      "name": "enabledHeliumToJourneyRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableJourneyToHeliumRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enableJourneyToHeliumRadio = "Disabled"
      }
    }
  }), _vm._v("\n                      Disabled\n                  ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled data updated on Helium will be synced to Journey's backend database.")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "heliumBookmarkIdHelpRef",
    staticClass: "col-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Base URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.helium.baseUrl),
      expression: "syncConfig.helium.baseUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.syncConfig.helium.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.helium, "baseUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Base URL for Helium.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Schema Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.helium.dbSchema),
      expression: "syncConfig.helium.dbSchema"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.syncConfig.helium.dbSchema)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.helium, "dbSchema", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Schema name of Helium app.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Changelog Starting Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.heliumToJourney.changeLogMinVersionAsString),
      expression: "syncConfig.heliumToJourney.changeLogMinVersionAsString"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyVersions,
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.heliumToJourney.changeLogMinVersionAsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.heliumToJourney, "changeLogMinVersionAsString", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("This integration was setup at this version, sync changes after this Helium bookmark ID."), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showHeliumBookmarkIdHelp,
      'btn-info': !_vm.showHeliumBookmarkIdHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnHeliumBookmarkIdHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Each database transaction persisted on Helium is assigned a unique and incrementing Bookmark ID. If a record is created, deleted or changes state after this Bookmark ID the data will be merged to Journey.\n\n                    See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Change+Tracking"
    }
  }, [_vm._v("Helium Change tracking Documentation")]), _vm._v(" for more info.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    A changelog version with value 0 indicates all changes from the beginning of time on the app should be processed.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildNewHeliumVersionSql),
      expression: "buildNewHeliumVersionSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyCallBack),
      expression: "onCopyCallBack",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])])]), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildNewHeliumVersionSql,
      "width": _vm.textEditorWidthHelium,
      "height": _vm.textEditorHeightHelium,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangHelium
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.readonlyVersions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Changelog Current Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumSyncStatus),
      expression: "heliumSyncStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumSyncStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumSyncStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Integration is currently at this bookmark version since " + _vm._s(new Date(new Number(_vm.heliumLastUpdatedMillis))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Change Log Skip Tables")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeLogSkipTablesTmp),
      expression: "changeLogSkipTablesTmp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.changeLogSkipTablesTmp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeLogSkipTablesTmp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Skip specific tables from syncing to Journey (Optional)"), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showHeliumSkipHelp,
      'btn-info': !_vm.showHeliumSkipHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnHeliumSkipHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Values are comma seperated (without spaces). Helium persistent objects which are not marked as @NotTracked must be explicitly added here.")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }) : _vm._e(), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildSkipHeliumViewsSql),
      expression: "buildSkipHeliumViewsSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyCallBack),
      expression: "onCopyCallBack",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])]), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildSkipHeliumViewsSql,
      "width": _vm.textEditorWidthHelium,
      "height": _vm.textEditorHeightHelium,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangHelium
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Base URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.baseUrl),
      expression: "syncConfig.journey.baseUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey, "baseUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Base URL for Journey. To find this, go to the API Management page for your app on Journey. The baseURL is the domain before /api/v4/{app-id}. \n                    eg. https://{app-deployment-id}.backend.{region-code}.journeyapps.com")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey API Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.restAPICredentials.userName),
      expression: "syncConfig.journey.restAPICredentials.userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.restAPICredentials.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey.restAPICredentials, "userName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey backend API basic auth username.")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey API Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.restAPICredentials.password),
      expression: "syncConfig.journey.restAPICredentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "password"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.restAPICredentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey.restAPICredentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey backend API basic auth password.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Starting Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHelium.oplogMinVersionAsString),
      expression: "syncConfig.journeyToHelium.oplogMinVersionAsString"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyVersions,
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHelium.oplogMinVersionAsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHelium, "oplogMinVersionAsString", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Sync changes after this Journey Version."), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showJourneyVersionHelp,
      'btn-info': !_vm.showJourneyVersionHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnJourneyVersionHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Each individual database operation on Journey is assigned a unique and incrementing version number known as the Sequence ID on Journey. If a record is created, deleted or changes state after this Sequence ID the data will be merged to Helium. See "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#oplog"
    }
  }, [_vm._v("Journey Oplog Documentation")]), _vm._v(" for more info.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A value of 0 indicates all changes from the beginning of time on the app should be processed.")]) : _vm._e(), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildNewJourneyVersionSql),
      expression: "buildNewJourneyVersionSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyResetJourneyVersion),
      expression: "onCopyResetJourneyVersion",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])])]), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildNewJourneyVersionSql,
      "width": _vm.textEditorWidthJourney,
      "height": _vm.textEditorHeightJourney,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangJourney
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.readonlyVersions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Current Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.journeySyncStatus),
      expression: "journeySyncStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.journeySyncStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.journeySyncStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Integration is currently at this bookmark version since " + _vm._s(new Date(new Number(_vm.journeyLastUpdatedMillis))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Skip Object Types")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oplogSkipObjectTypesTmp),
      expression: "oplogSkipObjectTypesTmp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.oplogSkipObjectTypesTmp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oplogSkipObjectTypesTmp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Skip specific tables from syncing to Helium (Optional)"), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showJourneySkipHelp,
      'btn-info': !_vm.showJourneySkipHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnJourneySkipHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showJourneySkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Values are comma seperated (without spaces). Journey objects which are not declared on Helium must be explicitly added here. Using "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")]), _vm._v(" is suggested over using this field.")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.expand) ? _c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Journey enrollments and metadata:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledEnrollmentRadio),
      expression: "enabledEnrollmentRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentRadio1",
      "name": "enrollmentRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledEnrollmentRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledEnrollmentRadio = "Enabled"
      }
    }
  }), _vm._v("\n                      Enabled\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledEnrollmentRadio),
      expression: "enabledEnrollmentRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentRadio2",
      "name": "enrollmentRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledEnrollmentRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledEnrollmentRadio = "Disabled"
      }
    }
  }), _vm._v("\n                        Disabled\n                      ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled mobile user re-enrollment tasks are processed and Journey user enrollment meta data is merged into the application data model.")])])]), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enrollmentModeRadio),
      expression: "enrollmentModeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentModeRadio1",
      "name": "enrollmentModeRadios",
      "type": "radio",
      "value": "Single device per user"
    },
    domProps: {
      "checked": _vm._q(_vm.enrollmentModeRadio, "Single device per user")
    },
    on: {
      "change": function($event) {
        _vm.enrollmentModeRadio = "Single device per user"
      }
    }
  }), _vm._v("\n                      Single device per user\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enrollmentModeRadio),
      expression: "enrollmentModeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentModeRadio2",
      "name": "enrollmentModeRadios",
      "type": "radio",
      "value": "Multiple devices per user"
    },
    domProps: {
      "checked": _vm._q(_vm.enrollmentModeRadio, "Multiple devices per user")
    },
    on: {
      "change": function($event) {
        _vm.enrollmentModeRadio = "Multiple devices per user"
      }
    }
  }), _vm._v("\n                        Multiple devices per user\n                      ")])])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey handles user enrollments in two possible ways. If support for multiple devices per user is enabled for a Journey app then 'Multiple devices per user' should be selected otherwise 'Single device per user' should be used.")])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.enrollmentMode === 'user') ? _c('div', [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey user enrollment metadata is extraced and persisted into the mobile user worker objects '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "' and '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName) + "'. ")]), _vm._v(" "), _vm._m(8)]) : _c('div', [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey user enrollment metadata is extraced and persisted into the mobile user worker objects '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "' and '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName) + "'. User session data is persisted into '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName) + "' and user session container data is persisted into '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName) + "'.")]), _vm._v(" "), _vm._m(9)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Update Interval Mins")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.updateIntervalMins),
      expression: "syncConfig.journeyToHeliumEnrollment.updateIntervalMins"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "updateIntervalMins", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.updateIntervalValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Number of minutes to wait between runs of the Journey-to-Helium synchronization of enrollment data. The default value is 15 and the minimum value is 5.")])]) : _vm._e()])]), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('legend', [_vm._v("\n              User:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The User object represents  users who are enrolled on a Journey app. Each user has available metadata for enrollment and session management.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.heliumObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "heliumObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that represents the Journey user.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.journeyObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "journeyObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Journey object that represents the Journey user.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('legend', [_vm._v("\n              User field names:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Names of fields in Helium persistent object for Journey user.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'user') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Allowed Access Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "allowedAccessFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is allowed to access the Journey app. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrolled Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrolledFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrolledFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is currently enrolled. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey Launcher Version Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "journeyLauncherVersionFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the version for the Journey Launcher last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Device OS Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.deviceOsFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.deviceOsFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.deviceOsFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "deviceOsFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the description of the device operating system last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Perform Re-Enrollment Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "performReEnrollmentFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if re-enrollment must be triggered for the user. When specified, this field is read by the Helium-to-Journey sync process. Setting the flag to a value that equates to \"true\", will trigger a re-enrollment against the Journey user management API. Once the re-enrollment has been triggered, the flag will be set back to a value that equates to \"false\" and the reEnrollmentLastProcessedFieldName will be updated. Note that Helium-to-Journey synchronization must be enabled for this flag to be processed. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f.  For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Generate Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "generateEnrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger generating enrollment code. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Device Model Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.deviceModelFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.deviceModelFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.deviceModelFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "deviceModelFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the description of the device model last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lastConnectedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Barcode Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.barcodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.barcodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.barcodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "barcodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the URL to the Journey enrollment barcode for the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("URL Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.urlFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.urlFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.urlFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "urlFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the URL to the Journey enrollment page for the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Re Enrollment Last Processed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "reEnrollmentLastProcessedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the last re-enrollment request was processed for the user. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains an enrollment code. An enrollment code is used when enrolling with the journey-enrollment-service. The field type must be string")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Generate Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "generateEnrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger generating enrollment code. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains an enrollment code. An enrollment code is used when enrolling with the journey-enrollment-service. The field type must be string.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Locked Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lockedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lockedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lockedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lockedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if a user is locked out of the Journey application. When a user is locked they are signed out if busy in a session and cannot log into the Journey application. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lastConnectedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrolled Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrolledFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrolledFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is currently enrolled. The field type may be boolean or string. For string fields the possible values are Yes and No.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User Session:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The User session object represents the sessions of users who are enrolled on a Journey app.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "sessionObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that contains device session data for Journey users. This table will be truncated and populated each update interval.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User session object field names:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            Names of fields in Helium persistent object for Journey user session data")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("State Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "stateFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains string representation of a Sessions state. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Authenticated At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "lastAuthenticatedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last authenticated. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Created At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "createdAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was created. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Object Fk Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "heliumObjectFkFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name of the id field in the Helium persistent object that contains the FK to the mobile user object on Helium '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "'. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Perform Re-Authenticate Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "performReAuthenticateFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger re authenticating a users session. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Re-Authenticated Last Processed Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "reAuthenticateLastProcessedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the last re-authenticate request was processed for the user. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Signed Out At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "signedOutAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last signed out. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "lastConnectedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Label Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "labelFieldname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains Journey Session Label. The field type must be string.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User Session Container:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            The User session container object represents the container of the session of enrolled Journey app users")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Container Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "sessionContainerObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that contains device container data for Journey user sessions")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("User Session Container field names:")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            Names of fields in Helium persistent object for Journey user session container data")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Version Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "versionFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains Journey container version for a device. An example value is '3.30.3'. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Bundle ID Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "bundleIdFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains Journey application bundle id. An example value is xyz.appinstall.myapp. The field type must be string.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Platform Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "platformFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains device platform name. An example value is IOS or Chrome. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Object FK Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "sessionObjectFkFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains FK the to the session that this container belongs. The field type must be UUID")])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveBtn
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("Back")])])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Merge")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-database"
  }), _vm._v(" Data Source")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" App")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info pull-right",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Please note")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Remember to disable the middleware before attempting a Helium Upgrade. When set as enabled data for this integration will be processed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                            Use the following SQL statements to extract the last bookmark and create a new bookmark if needed.\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                              Use the following SQL statement to list all SQL views and SQL materialized views.\n                              Please note: If there aren't any materialized views it will leave a trailing comma that should not be added to the \"Change Log Skip Tables\" input.\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Integration leverages Journey's Backend API. See "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#backend-api"
    }
  }, [_vm._v("Journey API Documentation")]), _vm._v(" for more info.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                            Use the following in terminal to generate a new Journey version that represents now.\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey docs: "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#managing-mobile-users"
    }
  }, [_vm._v("Mobile users")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey docs: "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#managing-app-users-and-sessions"
    }
  }, [_vm._v("Mobile users and sessions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f58cb54","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SyncForm.vue
// module id = 594
// module chunks = 2